import { Button } from "@/components/ui/button"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { cn } from "@/lib/utils"
import { Bell } from "lucide-react"
import { useState } from "react"
import { useUnreadCount } from "../hooks/useUnreadCount"
import { NotificationList } from "./NotificationList"

const UNREAD_DISPLAY_CAP = 99

export const formatUnreadCount = (count: number): string => {
  return count > UNREAD_DISPLAY_CAP ? `${UNREAD_DISPLAY_CAP}+` : `${count}`
}

export const NotificationBell: React.FC = () => {
  const [open, setOpen] = useState(false)
  const { translate } = useTranslation()
  const { data: unreadCount } = useUnreadCount()
  const count = unreadCount?.count ?? 0
  const isCapped = count > UNREAD_DISPLAY_CAP

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          aria-label={translate("NOTIF/UI/BELL_ARIA", { count })}
          className="relative h-10 w-10"
        >
          <Bell className="h-4 w-4" aria-hidden="true" />
          {count > 0 ? (
            <span
              data-testid="notification-unread-badge"
              aria-hidden="true"
              className={cn(
                "absolute -right-0.5 -top-0.5 flex h-[18px] min-w-[18px] items-center justify-center rounded-full border-2 border-grey2 bg-primary text-[11px] font-bold leading-none text-primary-foreground",
                isCapped ? "px-1.5" : "px-1",
              )}
            >
              {formatUnreadCount(count)}
            </span>
          ) : null}
        </Button>
      </PopoverTrigger>
      {/* sideOffset 7: bell button bottom sits at 46px in the 52px header; default 4
          would put the popover edge 2px above the header border. 7 lands it 1px below. */}
      <PopoverContent align="end" sideOffset={7} className="w-[420px] p-0">
        <NotificationList open={open} onNavigateAway={() => setOpen(false)} />
      </PopoverContent>
    </Popover>
  )
}
